import styled from 'styled-components';

import { Text } from 'features/common/components/Text';

export const CustomFieldCard = styled.div`
	width: 320px;
	display: flex;
	cursor: pointer;
	min-width: 320px;
	max-width: 320px;
	width: fit-content;
	border-radius: 8px;
	padding: 16px 24px;
	flex-direction: column;
	background-color: ${({ theme }) => theme.colors.grey2};
	gap: 8px;
	min-height: 120px;
	height: fit-content;
`;

export const CardTitle = styled(Text)`
	font-size: 20px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

export const CardDescription = styled(Text)`
	opacity: 0.6;
	font-size: 14px;
	font-weight: 500;
	line-height: normal;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	background-color: ${({ theme }) => theme.colors.white2};
	border-radius: 4px;
	padding: 4px 4px;
	color: ${({ theme }) => theme.colors.black};
	max-height: 30px;
	max-width: 50%;
`;
